// Fecha local en formato YYYY-MM-DD (Honduras es UTC-6; usar toISOString
// directo daría la fecha de mañana por la noche). Ajusta el offset local.
export function fechaLocal(d = new Date()) {
  const offset = d.getTimezoneOffset() * 60000;
  return new Date(d.getTime() - offset).toISOString().slice(0, 10);
}

// YYYY-MM-DD de hace N días (para filtros de "últimos N días").
export function fechaLocalHaceDias(dias) {
  return fechaLocal(new Date(Date.now() - dias * 86400000));
}

// Hora local HH:MM (24h) actual, para mostrar al vender.
export function horaLocal(d = new Date()) {
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

// Timestamp (ISO) a guardar para una venta con la fecha YYYY-MM-DD elegida:
// - Si es HOY → null (el servidor usa now(), la hora exacta actual).
// - Si es una fecha pasada → esa fecha con la hora actual local.
export function timestampParaFecha(fechaYMD) {
  if (!fechaYMD || fechaYMD === fechaLocal()) return null;
  const [y, m, d] = fechaYMD.split('-').map(Number);
  const ahora = new Date();
  const dt = new Date(y, m - 1, d, ahora.getHours(), ahora.getMinutes(), ahora.getSeconds());
  return dt.toISOString();
}
